import { BaseComponentService } from 'src/app/services/_app/base-component.service';
import { LicenseAssignment } from 'src/app/models/license/license-assignment';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { LicenseService } from 'src/app/services/license.service';
import { License } from 'src/app/models/license/license.model';
import { ApiError } from 'src/app/models/api/api-error.model';
import { FormControl, FormGroup } from '@angular/forms';
import { AppTools } from 'src/app/utils/tools';

@Component({
  selector: 'app-user-assign-license-dialog',
  templateUrl: './user-assign-license-dialog.component.html',
  styleUrl: './user-assign-license-dialog.component.scss',
})
export class UserAssignLicenseDialogComponent implements OnInit {
  private _licenseService: LicenseService = inject(LicenseService);
  private _baseComponentService = inject(BaseComponentService);

  public userId?: string;
  public isPosting: boolean = false;
  public licenseAssignmentId?: string;
  public licensesFullListing: License[] = [];
  public formGroup: FormGroup = new FormGroup({
    license: new FormControl(),
    user: new FormControl(),
    key: new FormControl(),
  });

  constructor(
    public _dialogRef: MatDialogRef<UserAssignLicenseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.userId = this.data.userId;
    if (this.userId) this.formGroup.patchValue({ user: this.userId });
    this.licenseAssignmentId = this.data.licenseAssignmentId;
    if (this.licenseAssignmentId) {
      this.getLicenseAssignmentDetails();
      this.formGroup.get('license')?.disable();
    }
  }

  ngOnInit(): void {
    this.getLicensesFullListing();
  }

  async getLicensesFullListing() {
    this._licenseService.getLicensesFullMinListing().subscribe({
      next: (response) => {
        this.licensesFullListing = response.data.map(
          (json: any) => new License(json)
        );
      },
      error: (error) => {
        console.error('Licenses Full-Min Listing ERROR:', error);
      },
    });
  }

  async getLicenseAssignmentDetails() {
    this._licenseService
      .getLicenseAssignmentDetails(this.licenseAssignmentId)
      .subscribe({
        next: (response) => {
          const licenseAssignment = new LicenseAssignment(response.data);
          this.formGroup.patchValue({ license: licenseAssignment.license?.id });
          this.formGroup.patchValue({ user: licenseAssignment.user?.id });
          this.formGroup.patchValue({ key: licenseAssignment.key });
        },
        error: (error: unknown) => {
          console.error('License Assignment Details - ERROR:', error);
          this._dialogRef.close(false);
        },
      });
  }

  onConfirm() {
    this.isPosting = true;
    const formValue = this.formGroup.value;
    const formData = AppTools.removeNullAndReplaceWithUndefined({
      ...formValue,
    });
    const observer = {
      next: (_: any) => this._dialogRef.close(true),
      error: (error: unknown) => {
        this._baseComponentService.showErrorDialog({
          error: new ApiError(error),
        });
      },
    };
    const request = this.licenseAssignmentId
      ? this._licenseService.patchLicenseAssignment(
          this.licenseAssignmentId,
          formData
        )
      : this._licenseService.postLicenseAssignment(formData);
    request.subscribe(observer).add(() => (this.isPosting = false));
  }

  onDismiss(): void {
    this._dialogRef.close(false);
  }
}
